import React from "react";
import ppf1 from "../../../assets/childPage/ppf.png";
import ppf2 from "../../../assets/childPage/ppf Hero Image.png";
import ppf3 from "../../../assets/childPage/ppf Benefits Image.png";
import ContactUs from "./ContactUs";
import ScrollTop from "../../ScrollTop";

const PPF = () => {
  return (
    <>
    <ScrollTop />
      <div className="bg-gray-300 pb-5">
        <section className="bg-sky-500 flex sm:flex-row justify-center items-center gap-8 pb-6 px-4">
          <img
            src={ppf1}
            alt="ppf1"
            loading="lazy"
            className="max-w-48 sm:max-w-sm lg:max-w-lg xl:max-w-4xl 2xl:max-w-6xl max-h-full object-cover"
          />
          <h4
            style={{ fontFamily: "Ballega" }}
            className="text-white text-xl sm:text-5xl lg:text-6xl text-left"
          >
            Paint <br />
            Protection <br />
            Film
          </h4>
        </section>

        <section className="flex flex-col justify-center items-center gap-6 mt-4 sm:mt-16">
          <h4
            style={{ fontFamily: "Ballega" }}
            className="text-xl sm:text-5xl lg:text-6xl"
          >
            What is PPF?
          </h4>
          <p
            style={{ fontFamily: "Barlow Condensed" }}
            className="text-base text-start sm:text-center px-4 lg:px-16"
          >
            Paint protection film (PPF) is a clear or tinted film that protects
            a vehicle's paint from damage. It's made of a thin, flexible, and
            durable urethane layer that absorbs and disperses the energy of
            impacts, preventing scratches and chips. PPF can also protect
            against UV radiation, chemicals, and other elements.
          </p>
          <img src={ppf2} alt="ppf2" loading="lazy" />
        </section>

        <section className="flex flex-col justify-center- items-center gap-6 mt-4 sm:mt-16 px-4">
          <h4
            style={{ fontFamily: "Ballega" }}
            className="text-center text-xl sm:text-3xl lg:text-4xl"
          >
            Benefits of Paint Protection Film for Cars
          </h4>
          <p
            style={{ fontFamily: "Barlow Condensed" }}
            className="text-base text-start sm:text-center"
          >
            Car paint protection film (PPF) is important to maintain the
            appearance of your vehicle and its value. This clear and
            long-lasting layer protects your car from scratches, chips, UV rays,
            and road debris. PPF act as a barrier between your car and the
            environment damages, It reduces the risk of corrosion and fading.
            PPF is easy to clean and invisible which also enhance the original
            aesthetic value of your vehicle.
          </p>
        </section>

        <section
          style={{ fontFamily: "Ballega" }}
          className="text-base lg:flex justify-center items-center mx-4 lg:mx-16 px-4 py-6 mt-4 sm:mt-12 shadow-[-8px_-8px_20px_0px_rgba(0,_0,_0,_0.25)_inset,8px_8px_20px_0px_rgba(0,_0,_0,_0.25)_inset] rounded-xl"
        >
          <div className="lg:w-1/2">
            <h4
              style={{ fontFamily: "Ballega" }}
              className="text-2xl text-center lg:pl-8 lg:text-3xl"
            >
              Benefits of Paint Protection Film for Cars
            </h4>
            <div
              style={{ fontFamily: "Barlow Condensed" }}
              className="text-base px-4 sm:px-16 py-6"
            >
              <ul className="list-disc list-outside pl-6">
                <li className="mb-2">
                  Car paint protection films for cars are made of urethane which
                  acts as a barrier against environmental damage like road
                  debris, dirt, and scratches.
                </li>
                <li className="mb-2">
                  PPF also protects the car’s surface from fading over time.
                </li>
                <li className="mb-2">
                  PPF has self-healing properties by which minor scratches
                  disappears with exposure to heat.
                </li>
                <li className="mb-2">
                  By preserving the car’s original condition, it also maintains
                  its high resale value.
                </li>
                <li className="mb-2">
                  PPF can be a great practical investment for the car owners who
                  want to keep their car well-maintained.
                </li>
              </ul>
            </div>
          </div>
          <img src={ppf3} alt="ppf3" className="w-full lg:w-1/2" loading="lazy" />
        </section>
        <ContactUs />
      </div>
    </>
  );
};

export default PPF;
